if(typeof __WEBPACK_EXTERNAL_MODULE__47__ === 'undefined') {var e = new Error("Cannot find module 'bufferutil'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE__47__;